
import { useQuery } from '@tanstack/react-query';
import { fetchPropBotDetail } from '@/services/prop-bot/prop-bot-detail-service';
import { EnhancedPropBotStatsService } from '@/services/prop-bot/enhanced-prop-bot-stats-service';

export const usePropBotDetail = (botId: string) => {
  const propBotQuery = useQuery({
    queryKey: ['propBot', botId],
    queryFn: () => fetchPropBotDetail(botId),
  });

  const enhancedStatsQuery = useQuery({
    queryKey: ['propBotEnhancedStats', botId],
    queryFn: () => EnhancedPropBotStatsService.getEnhancedStats(botId, propBotQuery.data?.propDetails?.[0]),
    enabled: !!propBotQuery.data,
  });

  return {
    ...propBotQuery,
    enhancedStats: enhancedStatsQuery.data,
    isEnhancedStatsLoading: enhancedStatsQuery.isLoading,
  };
};
